import type { TFunction } from 'i18next'
import { toast } from 'sonner'
import { useAuthStore } from '@/stores/authStore'
import { useGeneratorStore } from '@/stores/generatorStore'

/**
 * Shows a refused `POST /generate` the same way wherever it was sent from (the generate button or
 * a history card's retry): an expired session and the usage limit open their modals, anything
 * else is a toast with the server's message.
 */
export function reportGenerateError(error: unknown, t: TFunction): void {
  const err = error as Record<string, unknown> | undefined
  if (err?.status === 401) {
    useGeneratorStore.getState().setSsoTokenExpiredModalOpen(true)
  } else if (err?.code === 'USAGE_LIMIT_EXCEEDED') {
    // 서버가 한도 초과로 거부 → 배너/버튼 상태를 즉시 동기화하고 안내 모달 표시
    const currentUser = useAuthStore.getState().user
    if (currentUser) {
      useAuthStore.getState().setUser({ ...currentUser, hasUsage: false })
    }
    useGeneratorStore.getState().setUsageLimitModalOpen(true)
  } else {
    const data = err?.data as Record<string, unknown> | undefined
    const message = data?.message || (err?.message as string) || t('pages.unknownError')
    toast.error(t('pages.generateFailed'), { description: String(message) })
  }
}
